<template>
  <v-container class="border">
    <h2>
      <v-toolbar flat>
        <v-toolbar-title>Create New Client</v-toolbar-title>
        <Alert
          class="mx-4 my-2"
          v-if="showAlert"
          text="Client created!"
          type="success"
        />
        <v-spacer></v-spacer>
      </v-toolbar>
    </h2>
    <v-form>
      <v-container class="pt-4 px-8">
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="newClient.name" label="Name" required />
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newClient.email" label="Email" required />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="newClient.phone" label="Phone" required />
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newClient.address" label="Address" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6"> </v-col>
          <v-col cols="6">
            <v-progress-circular
              v-if="creating"
              class="px-8"
              indeterminate
            ></v-progress-circular>
            <v-btn small @click="createClient" class="float-sm-right mt-2 mx-2">
              <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
              Create
            </v-btn>
            <v-btn small @click="cancelCreate" class="float-sm-right mt-2">
              <v-icon class="mr-1">mdi-cancel</v-icon>
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
  import Alert from '@/components/Alert.vue'

  export default {
    name: 'NewClient',
    components: { Alert },
    data() {
      const defaultClient = {
        account_id: this.$route.params.accountId,
        status: true,
      }

      return {
        creating: false,
        showAlert: false,
        newClient: defaultClient,
        statusOptions: [
          { text: 'Active', value: true },
          { text: 'Inactive', value: false },
        ],
      }
    },
    methods: {
      cancelCreate() {
        this.$emit('cancelClientCreate')
        this.newClient = {
          account_id: this.$route.params.accountId,
          status: true,
        }
        this.showAlert = false
      },
      createClient() {
        this.creating = true
        this.apiAddClient(this.newClient)
          .then(response => {
            this.$emit('clientCreated', response)
          })
          .catch(error => {
            console.log(error)
          })
        this.creating = false
        this.showAlert = true
        this.newClient = {
          account_id: this.$route.params.accountId,
          status: true,
        }
      },
    },
  }
</script>
